// Havalandırma & Klima Mock Data
// Split klima, merkezi sistem, kanal montajı takibi

export const havalandirmaSiparisler = [
    {
        id: 'hv-001',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-01-15',
        tedarikci: 'Daikin Türkiye',
        tedarikciFirmaId: 'f-040',
        marka: 'Daikin',
        model: 'FTXM35R',
        tur: 'Split Klima',
        kapasite: '12.000 BTU',
        miktar: 24,
        birim: 'adet',
        birimFiyat: 28000,
        toplamFiyat: 672000,
        durum: 'teslim',
        montajDurumu: 'devam',
        montajlanan: 12,
        insaatId: 'c1',
        kullanimAlani: 'A Blok - Daireler',
        not: '1. ve 2. kat montajları tamamlandı',
        createdAt: '2026-01-10T09:00:00Z',
        updatedAt: '2026-01-25T14:00:00Z',
    },
    {
        id: 'hv-002',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-01-15',
        tedarikci: 'Daikin Türkiye',
        tedarikciFirmaId: 'f-040',
        marka: 'Daikin',
        model: 'FTXM50R',
        tur: 'Split Klima',
        kapasite: '18.000 BTU',
        miktar: 16,
        birim: 'adet',
        birimFiyat: 35000,
        toplamFiyat: 560000,
        durum: 'teslim',
        montajDurumu: 'devam',
        montajlanan: 6,
        insaatId: 'c1',
        kullanimAlani: 'A Blok - Salonlar',
        not: 'Salon klimaları, büyük kapasiteli',
        createdAt: '2026-01-10T09:30:00Z',
        updatedAt: '2026-01-26T11:00:00Z',
    },
    {
        id: 'hv-003',
        siparisTarihi: '2026-01-12',
        teslimTarihi: '2026-01-18',
        tedarikci: 'Mitsubishi Electric',
        tedarikciFirmaId: 'f-041',
        marka: 'Mitsubishi',
        model: 'MSZ-AP25VG',
        tur: 'Split Klima',
        kapasite: '9.000 BTU',
        miktar: 20,
        birim: 'adet',
        birimFiyat: 24000,
        toplamFiyat: 480000,
        durum: 'teslim',
        montajDurumu: 'bekliyor',
        montajlanan: 0,
        insaatId: 'c1',
        kullanimAlani: 'B Blok - Yatak Odaları',
        not: 'Depoda bekliyor, B Blok iç işleri bitmeli',
        createdAt: '2026-01-12T10:00:00Z',
        updatedAt: '2026-01-18T16:00:00Z',
    },
    {
        id: 'hv-004',
        siparisTarihi: '2026-01-15',
        teslimTarihi: null,
        tedarikci: 'Daikin Türkiye',
        tedarikciFirmaId: 'f-040',
        marka: 'Daikin',
        model: 'FTXM35R',
        tur: 'Split Klima',
        kapasite: '12.000 BTU',
        miktar: 36,
        birim: 'adet',
        birimFiyat: 28000,
        toplamFiyat: 1008000,
        durum: 'bekliyor',
        montajDurumu: 'bekliyor',
        montajlanan: 0,
        insaatId: 'c2',
        kullanimAlani: 'A Blok - Daireler',
        not: 'İnşaat ilerledikçe teslimat planlanacak',
        createdAt: '2026-01-15T14:00:00Z',
        updatedAt: '2026-01-15T14:00:00Z',
    },
    {
        id: 'hv-005',
        siparisTarihi: '2026-01-08',
        teslimTarihi: '2026-01-12',
        tedarikci: 'Systemair',
        tedarikciFirmaId: 'f-042',
        marka: 'Systemair',
        model: 'DVSI 400EZ',
        tur: 'Aspiratör / Fan',
        kapasite: '400 m³/h',
        miktar: 40,
        birim: 'adet',
        birimFiyat: 3500,
        toplamFiyat: 140000,
        durum: 'teslim',
        montajDurumu: 'devam',
        montajlanan: 28,
        insaatId: 'c1',
        kullanimAlani: 'A-B Blok Banyo/WC',
        not: 'Banyo aspiratörleri',
        createdAt: '2026-01-08T08:00:00Z',
        updatedAt: '2026-01-22T10:00:00Z',
    },
    {
        id: 'hv-006',
        siparisTarihi: '2026-01-11',
        teslimTarihi: '2026-01-14',
        tedarikci: 'Bahçıvan Motor',
        tedarikciFirmaId: 'f-043',
        marka: 'Bahçıvan',
        model: 'BRDV 250',
        tur: 'Kanal Tipi Fan',
        kapasite: '250 m³/h',
        miktar: 8,
        birim: 'adet',
        birimFiyat: 6500,
        toplamFiyat: 52000,
        durum: 'teslim',
        montajDurumu: 'tamamlandi',
        montajlanan: 8,
        insaatId: 'c1',
        kullanimAlani: 'A Blok - Mutfak Havöz',
        not: 'Mutfak havalandırma tamamlandı',
        createdAt: '2026-01-11T09:00:00Z',
        updatedAt: '2026-01-20T15:00:00Z',
    },
    {
        id: 'hv-007',
        siparisTarihi: '2026-01-13',
        teslimTarihi: '2026-01-17',
        tedarikci: 'Venco',
        tedarikciFirmaId: 'f-044',
        marka: 'Venco',
        model: 'Spiral Kanal Ø200',
        tur: 'Havalandırma Kanalı',
        kapasite: '-',
        miktar: 120,
        birim: 'metre',
        birimFiyat: 350,
        toplamFiyat: 42000,
        durum: 'teslim',
        montajDurumu: 'devam',
        montajlanan: 85,
        insaatId: 'c1',
        kullanimAlani: 'A-B Blok Şaft İçi',
        not: 'Şaft içi kanal döşemesi',
        createdAt: '2026-01-13T10:00:00Z',
        updatedAt: '2026-01-24T12:00:00Z',
    },
    {
        id: 'hv-008',
        siparisTarihi: '2026-01-16',
        teslimTarihi: null,
        tedarikci: 'Mitsubishi Electric',
        tedarikciFirmaId: 'f-041',
        marka: 'Mitsubishi',
        model: 'MSZ-LN50VG',
        tur: 'Split Klima',
        kapasite: '18.000 BTU',
        miktar: 24,
        birim: 'adet',
        birimFiyat: 38000,
        toplamFiyat: 912000,
        durum: 'bekliyor',
        montajDurumu: 'bekliyor',
        montajlanan: 0,
        insaatId: 'c2',
        kullanimAlani: 'B-C Blok Salonlar',
        not: 'İkinci parti klima siparişi',
        createdAt: '2026-01-16T11:00:00Z',
        updatedAt: '2026-01-16T11:00:00Z',
    },
];

// Havalandırma türleri
export const havalandirmaTurleri = [
    { key: 'Split Klima', label: 'Split Klima', aciklama: 'Duvar tipi klima' },
    { key: 'Aspiratör / Fan', label: 'Aspiratör / Fan', aciklama: 'Banyo/WC havalandırma' },
    { key: 'Kanal Tipi Fan', label: 'Kanal Tipi Fan', aciklama: 'Mutfak/tesisat havalandırma' },
    { key: 'Havalandırma Kanalı', label: 'Havalandırma Kanalı', aciklama: 'Spiral/dikdörtgen kanal' },
    { key: 'VRF Sistem', label: 'VRF Sistem', aciklama: 'Merkezi klima sistemi' },
];

// İstatistikler
export const getHavalandirmaStats = (insaatId) => {
    const filtered = insaatId
        ? havalandirmaSiparisler.filter(s => s.insaatId === insaatId)
        : havalandirmaSiparisler;

    const toplamKalem = filtered.length;
    const toplamAdet = filtered.reduce((acc, s) => acc + s.miktar, 0);
    const montajlanan = filtered.reduce((acc, s) => acc + (s.montajlanan || 0), 0);
    const toplamMaliyet = filtered.reduce((acc, s) => acc + s.toplamFiyat, 0);

    return { toplamKalem, toplamAdet, montajlanan, toplamMaliyet };
};

// Helper
export const getHavalandirmaByInsaat = (insaatId) => {
    if (!insaatId) return havalandirmaSiparisler;
    return havalandirmaSiparisler.filter(s => s.insaatId === insaatId);
};
